module.exports = __webpack_public_path__ + "icon_keskustelu.5836ab649c763259f445.svg";